import React, { FC, useMemo } from "react";
import { AGDialog } from "../../components/AGDialog";
import { Box, Button, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../redux";
import { clearUnauthState } from "../../redux/reducers/auth.reducer";
import { useNavigate } from "react-router-dom";

const SessionExpiredDialog: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const authState = useAppSelector((state) => state.auth);

	const message = useMemo<{ text: string; buttonText: string }>(() => {
		if (authState.unauthorizedError) {
			return {
				text: "Your login session has expired",
				buttonText: "Login Again"
			};
		}

		if (authState.defaultPasswordError) {
			return {
				text: "Your default password has not been changed yet",
				buttonText: "Change Password"
			};
		}
		if (authState.resetPasswordError) {
			return {
				text: "Your account's password has expired. Please change your password.",
				buttonText: "Change Password"
			};
		}

		return { text: "", buttonText: "" };
	}, [authState.unauthorizedError, authState.defaultPasswordError, authState.resetPasswordError]);

	function handleLoginAgainClick() {
		if (authState.defaultPasswordError || authState.resetPasswordError) {
			navigate("/change-password");
		} else {
			dispatch(clearUnauthState());
		}
	}

	return (
		<AGDialog
			open={authState.unauthorizedError || authState.defaultPasswordError || authState.resetPasswordError}
			maxWidth="xs"
		>
			<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
				<Typography variant="h6" textAlign={"center"}>
					{message.text}
				</Typography>

				<Button variant="contained" sx={{ marginTop: 2 }} onClick={handleLoginAgainClick}>
					{message.buttonText}
				</Button>
			</Box>
		</AGDialog>
	);
};

export default SessionExpiredDialog;
